import type { ReactNode } from 'react';
import * as st from './styles.module.scss';

interface Props {
  title: string;
  value?: ReactNode;
  suffix?: string;
  suffixClass?: string;
  className?: string;
}

export const ItemInfo = ({
  title,
  value = null,
  suffix = '',
  suffixClass,
  className,
}: Props): JSX.Element => (
  <li className={st.item}>
    <span className={st.item__title}>{title}</span>
    <div className={`${st.item__value} ${className || ''}`}>
      {value}
      <span className={suffixClass}>{suffix}</span>
    </div>
  </li>
);
